var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ForumResponseBodyTextOutput"},_vm._l((_vm.ast),function(node,idx){return _c('ForumResponseBodyTextOutputNode',{key:idx,attrs:{"node":node,"basic-mention":_vm.basicMention,"chat-id":_vm.chatId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }